import { Component, Fragment, h, Host, Listen, Prop, State } from '@stencil/core'
import { ICall } from 'src/call/types'
import { Deferred } from 'src/utils/async'

@Component({
  tag: 'page-embed-call',
})
export class Embed {
  @Prop() call: ICall
  @Prop() autoplay = false
  @Prop() shareUrl: string

  @State() displayMode = 'normal'

  bootstrap: Deferred<any>
  videoPlayerEl: HTMLVideoPlayerElement

  componentWillLoad() {
    this.bootstrap = new Deferred()
    document.querySelector('inertia-app').waitFor(this.bootstrap.promise)
  }

  // https://caniuse.com/fullscreen
  videoPlayerExitFullScreen() {
    const el = document as any
    const cancelFunc = el.exitFullscreen || el.webkitCancelFullScreen
    if (cancelFunc) {
      cancelFunc.apply(el)
    }
  }

  // https://caniuse.com/fullscreen
  videoPlayerEnterFullScreen() {
    const el = this.videoPlayerEl as any
    const requestFunc = el.requestFullscreen || el.webkitRequestFullScreen
    if (requestFunc) {
      requestFunc.apply(el)
    }
  }

  // https://caniuse.com/fullscreen
  videoPlayerInFullScreen(): boolean {
    const el = document as any
    return !!el.fullscreenElement || !!el.webkitFullscreenElement
  }

  @Listen('fullscreenchange', { target: 'document' })
  @Listen('webkitfullscreenchange', { target: 'document' })
  videoPlayerFullScreenChanged() {
    this.displayMode = this.videoPlayerInFullScreen() ? 'fullscreen' : 'normal'
  }

  render() {
    return (
      <Host class='flex overflow-hidden'>
        <video-player
          trackingSessionId={'embed-' + this.call?.id}
          muxVideoTitle={'Embed - ' + this.call?.id}
          muxVideoId={`${this.call?.id}`}
          muxPageType='embed'
          autoplay={this.autoplay}
          iconSize='120px'
          class='w-full h-full'
          src={this.call?.video_url}
          onMetadataLoaded={() => this.bootstrap.resolve()}
          ref={(el) => {
            if (el) {
              this.videoPlayerEl = el
            }
          }}
          renderOverlay={() => (
            <div class='absolute top-0 right-0 left-0 m-3'>
              <video-call-chip call={this.call} avatar date />
            </div>
          )}
          renderActions={() => (
            <Fragment>
              <a href={this.shareUrl} target='_blank' class='cursor-pointer'>
                <ui-logo size='12px' />
                <ui-infotip bgColor='surface-low'>Play in Fathom</ui-infotip>
              </a>
              <ui-icon
                slot='action'
                class='z-menu text-lg cursor-pointer'
                icon={this.displayMode !== 'normal' ? 'arrows-angle-contract' : 'arrows-angle-expand'}
                onClick={() => {
                  if (this.videoPlayerInFullScreen()) {
                    this.videoPlayerExitFullScreen()
                  } else {
                    this.videoPlayerEnterFullScreen()
                  }
                }}
              />
            </Fragment>
          )}
        />
      </Host>
    )
  }
}
